import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Message } from 'primeng/primeng';
import { PqrTypificationService } from '../../../service/pqr-typification/pqr-typification.service';
import { PqrTypification } from '../../../class/pqr-typification';

@Component({
  selector: 'app-pqr-typification',
  templateUrl: './pqr-typification.component.html',
  styleUrls: ['./pqr-typification.component.scss']
})
export class PqrTypificationComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() infoPqrTypification: PqrTypification;
    public department: PqrTypification;
    public msgs: Message[] = [];
    public options: any;

    constructor(
        public departmentService: PqrTypificationService,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
    }

    public cancelPqrTypification () {
        this.close.emit(true);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/pqr-typifications/pqr-typification/pqr-typification.component.ts